<template>
  <span class="checkbox-policy-text">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'CheckboxPolicyText',
};
</script>
